@switch (themeService.brand() || Brand.ESSENT) {
  @case (Brand.ESSENT) {
    <app-theme-provider-essent-light>
      <router-outlet></router-outlet>
    </app-theme-provider-essent-light>
  }
  @case (Brand.ENERGIEDIRECT) {
    <app-theme-provider-energiedirect-light>
      <router-outlet></router-outlet>
    </app-theme-provider-energiedirect-light>
  }
  @case (Brand.SME) {
    <app-theme-provider-sme-light>
      <router-outlet></router-outlet>
    </app-theme-provider-sme-light>
  }
}
